import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import { useTranslation } from 'react-i18next';
import { Link, IconButton, Tooltip } from '@material-ui/core';
import { useSelector } from 'react-redux';
import DeleteIcon from '@material-ui/icons/Delete';
import { EvaluationTemplateModel } from '../../models/evaluationTemplateModel';
import {
  getEvaluationTemplatesReq,
  deleteEvaluationTemplateReq,
} from '../../api/evaulationTemplateApi';
import { ApplicationState } from '../../stores';
import { PersonRole } from '../../models/eums/personRole';
import { personHasRole } from '../../utils/personUtils';
import { getFileExtension } from '../../utils/mimeUtils';
import moment from 'moment';
import { localization } from 'config/localization';

export default function EvaluationTemplatesView() {
  const { t } = useTranslation();
  const [evaluationTemplates, setEvaluationTemplates] = useState<EvaluationTemplateModel[]>([]);
  const isLoading = useSelector<ApplicationState, boolean>(state => state.loader.loading);

  async function handleEvaluationTemplateDelete(evaluationTemplate: EvaluationTemplateModel) {
    await deleteEvaluationTemplateReq(evaluationTemplate.id);
    const response = await getEvaluationTemplatesReq();
    if (response) {
      setEvaluationTemplates(response.data);
    }
  }

  useEffect(() => {
    async function getEvaluationTemplates() {
      const response = await getEvaluationTemplatesReq();
      if (response) {
        setEvaluationTemplates(response.data);
      }
    }
    getEvaluationTemplates();
  }, [setEvaluationTemplates]);

  return (
    <MaterialTable
      options={{
        minBodyHeight: '80vh',
        pageSize: 10,
        actionsColumnIndex: -1,
        headerStyle: {
          fontWeight: 'bold',
          backgroundColor: '#F5F5F5',
        },
      }}
      localization={localization()}
      columns={[
        {
          title: t('title'),
          field: 'title',
          render: evaluationTemplate => (
            <Link href={evaluationTemplate.file.url}>{evaluationTemplate.title}</Link>
          ),
        },
        { title: t('version'), field: 'version' },
        {
          title: t('uploaded_date'),
          field: 'uploadedDate',
          render: evaluationTemplate =>
            moment(evaluationTemplate.uploadedDate).format('DD.MM.YYYY.'),
        },
        {
          title: t('file_type'),
          field: 'fileType',
          render: evaluationTemplate => getFileExtension(evaluationTemplate.file.fileType),
        },
      ]}
      actions={
        personHasRole(PersonRole.Admin)
          ? [
              {
                icon: 'delete',
                onClick: (event, rowData) =>
                  handleEvaluationTemplateDelete(rowData as EvaluationTemplateModel),
              },
            ]
          : []
      }
      components={{
        Action: props => (
          <Tooltip id='button-delete' title={t<string>('delete_template')}>
            <span>
              <IconButton
                aria-label='delete'
                onClick={event => props.action.onClick(event, props.data)}
                size='small'
                disabled={isLoading}
                color='secondary'
              >
                <DeleteIcon />
              </IconButton>
            </span>
          </Tooltip>
        ),
      }}
      data={evaluationTemplates || []}
      title={t('evaluation_templates')}
    />
  );
}
